<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="p-card-field">
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Login type</label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText disabled v-model="login_type" id="login_type" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Fullname <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="fullname" id="fullname" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div v-if="login_type=='Email'" class="p-field p-grid">
          <label class="p-col-fixed in-d">Email <span style="color:red">*</span></label>
        </div>
        <div v-if="login_type=='Email'" class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="email" id="email" type="text" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Experience <span style="color:red">*</span></label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <input class="input_tmp_validator" id="experience_id_va">
                <Dropdown class="p-col-width-a" v-model="experience_id" :options="list_experience"
                  optionValue="id" optionLabel="name" placeholder="Select"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-field p-grid in-d">
          <label class="p-col-fixed">MAIN ACTIVE AREA</label>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Country</label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <input class="input_tmp_validator" id="country_id_va">
                <Dropdown class="p-col-width-a" v-model="country_id" :options="list_country"
                  optionValue="id" optionLabel="name" placeholder="Select" v-on:change="listProvice('change_country')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-fixed in-d">Main active area</label>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <div class="p-field p-grid">
              <div class="p-col">
                <div v-on:click="showMainActive" class="p-col-width-a">
                  <Dropdown class="p-col-width-a" placeholder="Choose"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <div class="p-col">
            <label v-for="(area, index) in main_active_area" :key="index" class="cus-tags">
              <span class="cs-tag">
                {{area.label}}
              </span>
              <i class="fas fa-times cs-icon" v-on:click="removeAreas(index)"></i>
            </label>
            <!-- <label class="cus-tags"><span class="cs-tag">Hồ Chí Minh</span><i class="fas fa-times cs-icon"></i></label>
            <label class="cus-tags"><span class="cs-tag">Đà Nẵng</span><i class="fas fa-times cs-icon"></i></label> -->
          </div>
        </div>
        <div v-if="login_type=='Email'" class="p-field p-grid in-d">
          <label class="p-col-fixed">New password</label>
        </div>
        <div v-if="login_type=='Email'" class="p-field p-grid">
          <div class="p-col">
            <InputText v-model="password" id="password" type="password" class="p-col-width-a" placeholder="Input" />
          </div>
        </div>
        <div class="p-field in-d">
          <label >
            <div class="container">
              <input v-if="active==false" type="checkbox" class="cus-checkbox" checked="checked" v-on:change="funtionUpdate($event)">
              <input v-else type="checkbox" class="cus-checkbox" v-on:change="funtionUpdate($event)">
              <span class="checkmark"></span>
              <span>Unactive</span>
            </div>
          </label>
        </div>      
      </div>
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning"
            style="width: 120px !important;"
          />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"

          />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"
          />
        </template>
      </Toolbar>
      <Dialog
        header="Choose main active area - City"
        :visible.sync="showChooseMain"
        :modal="true"
        class="cusss"
      >
        <table id="table_1" style="overflow-x: auto;border-collapse: collapse;">
          <tr>
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="checkAllProvince ? true: false" v-on:change="funtionProvinceCheckAll($event)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;">
                  All
                </span>
              </label>
            </td>
          </tr>
          <tr v-for="(province, index) in list_province" :key="index" v-bind:class="[province.total_choose > 0 ? 'class-tr' : '']">
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="province.total_choose > 0 ? true: false" v-on:change="funtionProvince($event,index)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;" v-bind:class="[province.total_choose > 0 ? 'text-cus' : '']">
                  {{province.name}}
                </span>
              </label>
              <div class="cs-text-right">
                <span v-bind:class="[province.total_choose > 0 ? 'text-cus' : '']">({{province.total_choose}}/{{province.total}})</span>
                <i class="fas fa-cog cs-icon-right" v-on:click="ShowDistrict(index,province.total_choose,province.total)"></i>
              </div>
            </td>
          </tr>
        </table>
        <template #footer>
          <Button
            label="Cancel"
            @click="showChooseMain = false"
            class="p-button-warning"
          />
          <Button label="Save" @click="SaveArea()" class="p-button-danger" />
        </template>
      </Dialog>
      <Dialog
        header="Choose main active area - District"
        :visible.sync="showChooseMainDistrict"
        :modal="true"
        class="cusss"
      >
        <table id="table_1" style="overflow-x: auto;border-collapse: collapse;">
          <tr>
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="checkAllDistrict ? true: false" v-on:change="funtionDistrictCheckAll($event)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;">
                  All
                </span>
              </label>
            </td>
          </tr>
          <tr v-for="(district, index) in list_district" :key="index" v-bind:class="[district.check==true ? 'class-tr' : '']">
            <td class="custom-div container-1">
              <label class="cus-lab">
                <input type="checkbox" class="cus-checkbox" :checked="district.check ? district.check : false" v-on:change="funtionDistrict($event,index)">
                <span class="checkmark1"></span>
                <span class="cs-tag" style="font-weight: 500;" v-bind:class="[district.check==true ? 'text-cus' : '']">
                  {{district.name}}
                </span>
              </label>
            </td>
          </tr>
        </table>
        <template #footer>
          <Button
            label="Cancel"
            @click="CancelDistrict()"
            class="p-button-warning"
          />
          <Button label="Save" @click="Savedistrict()" class="p-button-danger" />
        </template>
      </Dialog>
    </div>
  </form>
  
</template>

<script>
//import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";

export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
    id: String,
  },
  data() {
    return {
      showChooseMain : false,
      showChooseMainDistrict : false,
      fullname: '',
      email : '',
      phone: '',
      password: '',
      account_exist : false,
      validationErrors: {},
      formMode: this.mode,
      passwordVisible: false,
      active : true,
      login_type : '',
      username : '',
      experience_id : null,
      list_experience:[],
      country_id : null,
      list_district: [],
      list_country:[],
      list_province:[],
      list_province_last: [],
      checkAllProvince : false,
      checkAllProvince_old : false,
      checkAllDistrict: false,
      total_province: 0,
      total_province_choose: 0,
      total_district_choose : 0,
      province_id_main : 0,
      main_active_area: [],
      list_district_old : [],
      type_account : 'EMAIL'
    }
  },
  async mounted() {
    this.listExperience();
    this.listCountry();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("this.modelthis.model:this.model",this.model)
      if(this.model.accounts && this.model.accounts[0]){
        if(this.model.accounts[0].type == 'EMAIL'){
          this.login_type = 'Email'
        }else if(this.model.accounts[0].type == 'FACEBOOK'){
          this.login_type = 'Facebook'
        }else if(this.model.accounts[0].type == 'GOOGLE'){
          this.login_type = 'Google'
        }else if(this.model.accounts[0].type == 'APPLE'){
          this.login_type = 'Apple ID'
        }
        this.type_account = this.model.accounts[0].type
      }
      // this.model.email_old = this.model.email;
      this.fullname = this.model.fullname;
      this.email = this.model.email;
      // this.phone = this.model.phone;
      this.experience_id = this.model.experience_id ? this.model.experience_id : 1;
      this.active = this.model.active
      var country_id = this.model.country_id ? this.model.country_id : null;
      this.country_id = country_id
      if(country_id && country_id > 0){
        //lấy danh sách ra show
        var usere_main_area = this.model.usere_main_area ? this.model.usere_main_area : []
        var list_state= []
        if(usere_main_area.length > 0)
        for (let i = 0; i < usere_main_area.length; i++) {
          const e = usere_main_area[i];
          if(!list_state[e.province_id]){
            list_state[e.province_id] = {
              id : e.province_id,
              district_ids: e.district_id ? [e.district_id]: []
            }
          }else{
            if(list_state[e.province_id].district_ids.length > 0){
              list_state[e.province_id].district_ids.push(e.district_id)
            }
          }
        }
        // console.log("list_state===",list_state)
        await this.listProvice('data',list_state)
      }
    }
    
  },
  methods: {
    async funtionDistrict(e,index){
      var check = e.target.checked;
      var data1 = this.list_district[index];
      var data = Object.assign({},data1);
      if(check == true){
        data.check = true
      }else{
        data.check = false
      }
      this.$set(this.list_district,index,data);
      var count = 0
      for (let i = 0; i < this.list_district.length; i++) {
        var d = this.list_district[i]
        if(d.check==true){
          count++
        }
      }
      if(count == this.list_district.length){
        this.$set(this,"checkAllDistrict",true)
      }else{
        this.$set(this,"checkAllDistrict",false)
      }
      // console.log("this.list_province",this.list_province)
      // console.log("this.list_province_last",this.list_province_last)

    },
    async SaveArea(){
      await this.updateShowData();
      this.list_province_last = this.list_province
      this.checkAllProvince_old = this.checkAllProvince
      this.showChooseMain = false
    },
    async CancelDistrict(){
      this.list_district = this.list_district_old.map(m => { return {...m}})
      for (let i = 0; i < this.list_province.length; i++) {
        const e = this.list_province[i];
        if(e.id == this.province_id_main){
          this.$set(this.list_province[i],"districts", this.list_district);
          break;
        }
      }
      this.showChooseMainDistrict = false
    },
    async Savedistrict(){
      for (let i = 0; i < this.list_province.length; i++) {
        var e = this.list_province[i];
        if(e.id == this.province_id_main){
          var count = 0;
          for (let j = 0; j < this.list_district.length; j++) {
            const d = this.list_district[j];
            if(d.check == true){
              count++
            }
          }
          e.total_choose = count
          e.districts = this.list_district
          console.log(this.list_district,this.list_district)
          this.$set(this.list_province,i, e);
          break;
        }
      }
      this.showChooseMainDistrict = false
      // console.log("this.list_province",this.list_province)
      // console.log("this.list_province_last",this.list_province_last)
    },
    async ShowDistrict(index){
      var data = this.list_province[index];
      this.province_id_main = data.id
      this.list_district= data.districts.map(m => { return {...m}})
      this.list_district_old= data.districts.map(m => { return {...m}})
      if(data.total_choose == data.total){
        this.checkAllDistrict = true
      }else{
        this.checkAllDistrict = false
      }
      this.showChooseMainDistrict = true
    },
    async updateShowData(data_show){
      var data = data_show ? data_show : this.list_province
      var main_active_area = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        if(e.total_choose == e.total){
          main_active_area.push({
            id : e.id,
            is_all: true,
            district_id : null,
            label : "All "+e.name
          })
        }else if(e.total_choose > 0){
          for (let j = 0; j < e.districts.length; j++) {
            const d = e.districts[j];
            if(d.check == true){
              main_active_area.push({
                id : e.id,
                is_all: false,
                district_id : d.id,
                label : d.name + ', '+ e.name
              })
            }
          }
        }
      }
      this.main_active_area = main_active_area
      this.$set(this,"list_province_last",[...data])
      
    },
    async funtionProvince(e,index){
      var check = e.target.checked;
      var data1 = this.list_province[index];
      var data = Object.assign({},data1);
      if(check == true){
        data.total_choose = data.total
        this.total_province_choose++
        for (let i = 0; i < data.districts.length; i++) {
          data.districts[i].check = true
        }
      }else{
        data.total_choose = 0
        this.total_province_choose--
        // this.checkAllProvince = false
        for (let i = 0; i < data.districts.length; i++) {
          data.districts[i].check = false
        }
      }
      this.$set(this.list_province,index,data)
      if(this.total_province_choose == this.total_province){
        this.checkAllProvince = true
      }else{
        this.checkAllProvince = false
      }
      console.log("list_province",this.list_province)
      console.log("list_province_last",this.list_province_last)
    },
    async funtionProvinceCheckAll(e){
      var tmp = this.list_province_last.map(m => { return {...m}});
      var check = e.target.checked;
      // console.log("this.list_province_last",this.list_province_last)
      // console.log("this.list_province_last tmp", tmp)
      if(check){
        // console.log("this.list_province_last",this.list_province_last)
        this.checkAllProvince = true
        this.total_province_choose = this.list_province.length
        this.list_province.map(m => {
          if (m.total_choose == 0){
            m.total_choose = m.total;
            m.districts.map(d => {
              d.check = true;
            })
          }
        })
      } else{
        this.checkAllProvince = false
        this.total_province_choose = 0
        this.list_province.map(m => {
          m.total_choose = 0;
          m.districts.map(d => {
            d.check = false;
          })
        })
      }
      
      // this.list_province = data
      // var data = this.list_province;
      // this.$set(this,"list_province",this.list_province)
      this.$set(this, "list_province_last", tmp);
      // console.log("list_province",this.list_province)
      // console.log("list_province_last",this.list_province_last)
    },
    async funtionDistrictCheckAll(e){
      var tmp = this.list_province_last.map(m => { return {...m}});
      var check = e.target.checked;
      var data = this.list_district;
      if(check == true){
        this.checkAllDistrict = true
        this.total_district_choose = data.length
        this.list_district.map(m => {
          m.check = true;
        })
      }else{
        this.checkAllDistrict = false
        this.total_district_choose = 0
        this.list_district.map(m => {
          m.check = false;
        })
      }
      // this.$set(this,"list_district",this.list_district)
      this.$set(this, "list_province_last", tmp);
      // console.log("list_district",this.list_district)
      // console.log("list_province_last",this.list_province_last)
    },
    async showMainActive(){
      if(this.country_id){
      /**
       * Chọn All ngoài danh sách những cái đã chọn 0 thay đổi
       * Cái = 0 thì = all
       */
        var tmp = this.list_province_last.map(m => { return {...m}})
        this.$set(this,"list_province",tmp)
        // console.log("list_province",this.list_province_last)
        this.checkAllProvince = this.checkAllProvince_old;
        this.showChooseMain = true
      }else{
        this.showChooseMain = false
      }
    },
    async listProvice(key,map_data=[]){
      if(key=="change_country"){
        this.checkAllProvince = false;
        this.checkAllProvince_old = false
      }
      var country_id = this.country_id
      if(country_id){
        var {data} = await this.$apollo.query({
          query: DataServices.getList('province',{"fields" : `id ordinal province_lang(where: {lang: {_eq: "en"}}){lang name} districts(order_by: {ordinal: desc}){id district_lang(where: {lang: {_eq: "en"}}){lang name}}`}),
          variables: {
            where_key: {
              country_id: {'_eq': country_id},
              deleted: {'_eq': false},
              active: {'_eq': true}
            },
            orderBy:{ordinal: 'desc'}
          },
          fetchPolicy: "network-only"
        })
        var model = data[Object.keys(data)];
        if (model.length > 0) {
          var tmp = []
          for (let i = 0; i < model.length; i++) {
            const e = model[i];
            var districts = []
            var tmp_check = map_data[e.id] ? map_data[e.id] : null
            var total_choose = 0
            if(e.districts.length > 0){
              for (let k = 0; k < e.districts.length; k++) {
                const d = e.districts[k];
                var check_district = false
                if(tmp_check){
                  if(tmp_check.district_ids.length == 0 || tmp_check.district_ids.includes(d.id)){
                    check_district = true
                    total_choose++
                  }
                }
                districts.push({
                  id: d.id,
                  name: d.district_lang[0].name,
                  check : check_district,
                })
              }
            }
            tmp.push({
              id : e.id,
              name : e.province_lang[0].name,
              total_choose : total_choose,
              total : e.districts ? e.districts.length : 0,
              districts: districts,
            })
          }
          this.list_province_last = tmp;
          this.total_province = tmp.length
        }else{
          this.list_province_last = []
          this.total_province = 0
        }
      }else{
        this.list_province_last = []
      }
      this.updateShowData(tmp)
      // console.log("this.list_province_last",this.list_province_last)
    },
    async removeAreas(index){
      var tmp = this.main_active_area[index];
      // console.log("tmptmptmp",tmp)
      for (let i = 0; i < this.list_province_last.length; i++) {
        var plast = this.list_province_last[i];
        var change = false;
        if(plast.id == tmp.id){
          if(tmp.is_all == true){
            plast.total_choose = 0
            for (let j = 0; j < plast.districts.length; j++) {
              plast.districts[j].check = false
            }
            change = true
          }else if(tmp.district_id){
            for (let j = 0; j < plast.districts.length; j++) {
              if(plast.districts[j].id == tmp.district_id){
                plast.districts[j].check = false;
                plast.total_choose--;
                change = true
                break
              }
            }
          }
        }
        if(change == true){
          this.$set(this.list_province_last,i,plast)
        }
      }
      this.main_active_area.splice(index, 1)
    },
    async listCountry() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('country',{"fields" : `id ordinal country_lang(where: {lang: {_eq: "en"}}){lang name}`}),
        variables: {
          where_key: {
            deleted: {'_eq': false},
            active: {'_eq': true}
          },
          orderBy:{ordinal: 'asc'}
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        var tmp = []
        for (let i = 0; i < model.length; i++) {
          const e = model[i];
          tmp.push({
            id : e.id,
            name : e.country_lang[0].name
          })
        }
        this.list_country = tmp;
      }else{
        this.list_country = []
      }
    },
    async listExperience() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('experience',{"fields" : `id ordinal experience_lang(where: {lang: {_eq: "en"}}){lang name}`}),
        variables: {
          where_key: {
            deleted: {'_eq': false},
            active: {'_eq': true}
          },
          orderBy:{ordinal: 'asc'}
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        var tmp = []
        for (let i = 0; i < model.length; i++) {
          const e = model[i];
          tmp.push({
            id : e.id,
            name : e.experience_lang[0].name
          })
        }
        this.list_experience = tmp;
      }else{
        this.list_experience = []
      }
    },
    funtionUpdate(e){
      var check = e.target.checked;
      this.active = !check
    },
    backToList() {
      this.$emit('back');
    },

    async validateData() {
      let fullname = document.getElementById("fullname");
      if (this.fullname == undefined || this.fullname == null || this.fullname == ''){
        fullname.setCustomValidity("Fullname is not empty");
      }else{
        fullname.setCustomValidity("")
      }
      if(this.type_account == "EMAIL"){
        let email = document.getElementById("email");
        if (this.email == undefined || this.email == null || this.email == ''){
          email.setCustomValidity("Email is not empty");
        }else {
          // kiểm tra email tồn tại chưa
          let account_email_exist = await this.checkEmailExist();
          if(account_email_exist){
            email.setCustomValidity("Email is exsit");
          }else{
            email.setCustomValidity("");
          }
        }
      }
      var experience_id_va = document.getElementById("experience_id_va");
      if (this.$commonFuction.isEmpty(this.experience_id)) {
        experience_id_va.setCustomValidity("Select experience");
      } else {
        experience_id_va.setCustomValidity("");
      }

      if(this.type_account == "EMAIL"){
        var password = document.getElementById("password");
        if(this.password.length>0 && this.password.length < 6){
          password.setCustomValidity("Password must have 6 characters or more");
        }else{
          password.setCustomValidity("");
        }
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }

    },
    convertPhone(numberPhone) {
      var phone = numberPhone
      if (numberPhone[0] === '0') {
        phone = phone.substring(1);
      }
      phone = phone.replace(' ', '')
      phone = '+84' + phone
      return phone
    },
    async getUserByPhoneNumber(phoneNumber) {
      // var phone = phoneNumber;
      // if (phoneNumber[0] === "0") {
      //   phone = phone.substring(1);
      // }
      // phone = phone.replace(' ', '');
      // phone = "+84" + phone;
      let query = `mutation MyMutation {
        checkPhoneNumber(phone: "${this.convertPhone(phoneNumber)}") {
          info
        }
      }`;
      await this.$apollo.mutate({
        mutation: gql(query)
      }).then(async(res) => {
        // console.log('=========> checkPhoneNumber: ', res)
        if (res) {
          this.firebaseID = res.data.checkPhoneNumber.info.uid
          await this.$apollo.query({
            query: DataServices.getList('users', {"fields" : "id"}),
            variables: {
              where_key: {
                phone: {'_eq': this.phone},
                deleted: {'_eq': false}
              }
            },
            fetchPolicy: "network-only"
          }).then((res) => {
            if (res && res.data.users.length > 0) this.userID = res.data.users[0].id
            else this.userID = null
            // console.log(this.userID)
          }).catch((error) => {
            console.log('ERROR: ', error.message)
          })
        }
      }).catch((error) => {
        console.log('ERROR: ', error.message)
        // CHƯA CÓ FIREBASE ID
        this.firebaseID = null
        this.userID = null
      })
    },
    async checkPhoneExist() {
      if (this.phone !== undefined && this.phone !== "") {
        // var phone = this.phone;
        // if (this.phone[0] === "0") {
        //   phone = phone.substring(1);
        // }
        // phone = phone.replace(' ', '');
        // phone = "+84" + phone;

        var where = {
          phone: {'_eq': this.phone},
          // type: {'_eq': 'PHONE'},
          deleted: {'_eq': false}
        }
        if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
        var {data} = await this.$apollo.query({
          query: DataServices.getList('users', {"fields" : "id, phone"}),
          variables: {
            where_key: where
          },
          fetchPolicy: "network-only"
        })
        console.log(data)
        return data && data[Object.keys(data)].length > 0
      }
    },
    async checkEmailExist() {
      if (this.email !== undefined && this.email !== "") {
        var where = {
          email: {'_eq': this.email},
          // type: {'_eq': 'PHONE'},
          deleted: {'_eq': false}
        }
        if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
        var {data} = await this.$apollo.query({
          query: DataServices.getList('users', {"fields" : "id, email"}),
          variables: {
            where_key: where
          },
          fetchPolicy: "network-only"
        })
        // console.log(data)
        return data && data[Object.keys(data)].length > 0
      }
    },

    async saveData() {

     /* if(this.saving == true){
        return;
      }
      this.saving = true;*/
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
       // this.saving = false;
        this.$commonFuction.is_loading(false);
        return
      }
      var main_active_area = this.main_active_area ? this.main_active_area : []
      
      // console.log("main_insert==",main_insert)
      var params = {
        fullname: this.fullname,
        email: this.email,
        phone: this.phone,
        password : this.password,
        main_active_area : main_active_area,
        type_account : this.type_account,
        active : this.active,
        experience_id :this.experience_id,
        country_id :this.country_id,
      }
      console.log("params", params)
      this.$emit('save', params);
    
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
  },

}
</script>

<style lang="scss">
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-col-width-a{
    max-width: 600px
  }
  .in-d {
    font-weight: 700;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
  }
  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #ccc;
  }
  .checkmark1 {
    position: absolute;
    top: 8px;
    left: 4px;
    height: 20px;
    width: 20px;
    background-color: #ccc;
    cursor: pointer;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: #e95d57;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .container input:checked ~ .checkmark{
    background-color:#E73725 !important; ;
  }
  .cus-tags{
    border-radius: 18px;
    padding: 8px;
    margin-right: 10px;
    background-color:#F2F3F7;
  }
  .cs-tag {
    padding: 10px 12px 10px 0px;
  }
  .cs-icon {
    color : #666666;
    padding-right: 4px;
    cursor: pointer;
  }
  .cs-icon-right {
    cursor: pointer;
  }
  .cs-text-right {
    color : #666666;
    float: right;
  }
  .custom-div{
    width: 500px;
    padding: 6px 6px 0px 30px;
    
  }
  .custom-div-check {
    border-width: 1px;
    border-style: solid;
  }
  .container-1 {
    display: block;
    position: relative;
    padding-left: 35px;
  }
  /* Hide the browser's default checkbox */
  .container-1 input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  
  /* On mouse-over, add a grey background color */
  .container-1:hover input ~ .checkmark1 {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container-1 input:checked ~ .checkmark1 {
    background-color: #e95d57;
  }
  /* Show the checkmark when checked */
  .container-1 input:checked ~ .checkmark1:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container-1 .checkmark1:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .container-1 input:checked ~ .checkmark1{
    background-color:#E73725 !important; ;
  }
  .cus-lab {
    cursor: pointer;
  }
  .container-1 .checkmark1:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .container-1 input:checked ~ .checkmark1{
    background-color:#E73725 !important; ;
  }
  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container-1 input:checked ~ .checkmark1 {
    background-color: #e95d57;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark1:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container-1 input:checked ~ .checkmark1:after {
    display: block;
  }

  .cusss .p-dialog-header-icons {
    display: none;
    align-items: center;
  }
  .class-tr {
    border: 3px solid red;
  }
  .text-cus {
    color : red;
    font-weight: 500;
  }
</style>
